"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseProvider = void 0;
exports.isProvider = isProvider;
const utils_1 = require("./utils");
class BaseProvider {
    props;
    constructor(props = {}) {
        this.props = props;
    }
    mergeBaseProps(props) {
        return this.merge(props);
    }
    interpretation(interpretation) {
        return this.mergeBaseProps((0, utils_1.pushInterpretation)(this.props, interpretation));
    }
    tag(tag) {
        return this.mergeBaseProps((0, utils_1.pushTag)(this.props, tag));
    }
    expiration(expiration) {
        return this.mergeBaseProps({ expiration });
    }
    unit(unit) {
        return this.mergeBaseProps({ unit });
    }
    logProps({ ctx }) {
        ctx.addMessageWithPath(this.getPropsToLog());
    }
    getPropsToLog() {
        return this.props;
    }
    getAllPossibleInterpretations() {
        return this.props.interpretations || [];
    }
    getAllPossibleTags() {
        return this.props.tags || [];
    }
}
exports.BaseProvider = BaseProvider;
function isProvider(value) {
    return (typeof value === "object" &&
        value !== null &&
        !Array.isArray(value) &&
        "evaluate" in value);
}
